// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__4WdeM","label":"Collapse_label__PfY2q","collapseContent":"Collapse_collapseContent__YZTPz"};